import React, { useEffect } from 'react';
import { SearchBreadcrumb, SearchBreadcrumbModifier } from '../../../../SearchBreadcrumb';
import { DownloadFileIcon } from '../../../../../../_lib/components/Download';
import { ButtonMinorAction } from '../../../../Btn/ButtonWrapper';
import { Icons } from '../../../../../atoms/SVG';
import { TooltipPlacement } from '../../../../../atoms/Tooltip';
import { sendLiveRegionMessage } from '../../../../../atoms/LiveRegionGlobal/LiveRegionGlobal';
import { StateIndicator } from '../../../../../../_lib/components/StateIndicator';
import { useSonTranslation } from '../../../../../../translation/useSonTranslation';
import { TopContentResult } from '../AbstractComboBox/types/SuggestResultTypes';
import { DownloadFileIconModifier } from '../../../../../../_lib/components/Download/DownloadFileIcon/DownloadFileIcon';

type ContentPreview = Partial<TopContentResult> & { reset(): void };

export function ContentPreview({
  pageLink,
  breadcrumb,
  teasertext,
  attachment,
  fileExtension,
  reset,
  packState,
}: ContentPreview) {
  const { t } = useSonTranslation('FormsComboBox');
  const pageLinkName = pageLink?.name;

  useEffect(() => {
    if (pageLinkName) {
      sendLiveRegionMessage(t('contentPreview.hint', { name: pageLinkName }));
    }
  }, [pageLinkName, t]);

  return (
    <div className="content-preview">
      <h3 className="content-preview__headline invisible">{t('contentPreview.content')}</h3>
      <div className="content-preview__wrapper">
        <div className="content-preview__content">
          <p className="content-preview__title">
            {packState === 'onlyDraftVersion' && <StateIndicator status="red" />}
            {attachment && fileExtension && (
              <DownloadFileIcon modifier={DownloadFileIconModifier.RELATIVE} fileExtension={fileExtension} />
            )}
            {pageLinkName}
          </p>
          {breadcrumb && (
            <SearchBreadcrumb
              clickable={false}
              breadcrumbs={breadcrumb}
              modifier={SearchBreadcrumbModifier.NO_MARGIN_BOTTOM}
            />
          )}
          {teasertext && <p className="content-preview__teasertext">{teasertext}</p>}
        </div>
        <ButtonMinorAction
          icon={Icons.DELETE_X_SMALL}
          text={t('contentPreview.deleteButtonText')}
          onClick={reset}
          tooltipPlacement={TooltipPlacement.LEFT}
        />
      </div>
    </div>
  );
}
